<div class="modal-content">
  <div class="modal-header">
    <span class="modal-title" id="addPageModalTitleId">
      Undo/Redo History
    </span>
    <i class="material-icons" data-bs-dismiss="modal" (click)='closeUndoRedoPopUp()'>close</i>
  </div>
  <div class="modal-body" style="min-height: 200px;">
    <tabset [justified]="true">
      <tab heading="Undo History">
        @for (undoData of undoHistory; track undoData; let i = $index) {
          <div class="row allign-items-center undo-redo-row"
            [ngClass]="i === 0 ? 'opacity-1' : 'opacity-65'">
            @if (undoData) {
              <div class="col-8 undo-redo-json">
                <h5 class="section-title" (click)="goToSection(undoData)">
                  {{undoData.sectionTitle ? undoData.sectionTitle : undoData.pageTitle}}
                </h5>
                @if (undoData.sectionTitle) {
                  <div>
                    {{undoData.pageTitle}}/{{undoData.sectionTitle}} @if (undoData.isDraftMode) {
                    <i>*Active Draft</i>
                  }
                </div>
              }
              <div class="col-12 ps-0"><b>Operation Type:&nbsp;</b>  {{undoData.operation}}</div>
              <div class="col-12 ps-0"><b>Modified by:&nbsp;</b>  {{undoData.createdByName}}</div>
              <div class="col-12 ps-0"><b>Modified on:&nbsp;</b>  {{undoData.lastUpdatedAt | formatTime : 'LLL' }}</div>
              <div>
              </div>
            </div>
          }
          @if (undoData && undoData.languageId !== this.languageId) {
            <div class="col-1">
              <a type="button" style="margin-top: 10px;" tooltip="Different language id than the current one. So, Page will be reloaded." placement="top">
                <span class="material-icons" style="color: gray">
                  info
                </span>
              </a>
            </div>
          }
          @if (undoData) {
            <div class="col-2">
              @if (!i) {
                <button  class="btn vPlaybookDefaultButton btn__btn-default icon_btn" (click)="undoApi(i,undoData)">
                  Undo
                  <span class="material-icons icon_design">
                    undo
                  </span>
                </button>
              }
            </div>
          }
        </div>
      }
      @if (undoHistory && !undoHistory.length) {
        <div class="col no-data-available">
          <div class="bg-color p-2">
            <strong>No Undo History Available</strong>
          </div>
        </div>
      }
    </tab>
    <tab heading="Redo History">
      @for (redoData of redoHistory; track redoData; let i = $index) {
        <div class="row allign-items-center undo-redo-row"
          [ngClass]="i === 0 ? 'opacity-1' : 'opacity-65'">
          @if (redoData) {
            <div class="col-8 undo-redo-json">
              <h5 class="section-title" (click)="goToSection(redoData)">
                {{redoData.sectionTitle ? redoData.sectionTitle : redoData.pageTitle}}
              </h5>
              @if (redoData.sectionTitle) {
                <div>
                  {{redoData.pageTitle}}/{{redoData.sectionTitle}} @if (redoData.isDraftMode) {
                  <i>*Active Draft</i>
                }
              </div>
            }
            <div>
              <div class="col-12 ps-0"><b>Operation Type:&nbsp;</b>  {{redoData.operation}}</div>
              <div class="col-12 ps-0"><b>Modified by:&nbsp;</b>{{redoData.createdByName}}</div>
              <div class="col-12 ps-0"><b>Modified on:&nbsp;</b>{{redoData.lastUpdatedAt| formatTime : 'LLL'}}</div>
            </div>
          </div>
        }
        @if (redoData && redoData.languageId !== this.languageId) {
          <div class="col-1">
            <a type="button" style="margin-top: 10px;"
              tooltip="Different language id than the current one. So, Page will be reloaded." placement="top">
              <span class="material-icons" style="color: gray">
                info
              </span>
            </a>
          </div>
        }
        @if (redoData) {
          <div class="col-2">
            @if (!i) {
              <button class="btn vPlaybookDefaultButton btn__btn-default icon_btn" (click)="redoApi(i,redoData)">
                Redo
                <span class="material-icons icon_design">
                  redo
                </span>
              </button>
            }
          </div>
        }
      </div>
    }
    @if (redoHistory && !redoHistory.length) {
      <div class="col no-data-available">
        <div class="bg-color p-2">
          <strong>No Redo History Available</strong>
        </div>
      </div>
    }
  </tab>
</tabset>
</div>
<div class="modal-footer">
  <button type="button" class="btn vPlaybookDefaultButton btn__btn-default" data-bs-dismiss="modal"
  (click)='closeUndoRedoPopUp()'>Close</button>
</div>
</div>
